import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class MapService {
  geocoder;

  eventBus: Subject<any> = new Subject<any>();

  constructor() {
    this.geocoder = new AMap.Geocoder({
      city: '全国'
    });
  }

  /** 地址转换成经纬度 */
  getLocation(address: string, cb: Function) {
    return this.geocoder.getLocation(address, cb);
  }

  /** 经纬度转换成地址 */
  getAddress(location: [number, number], cb: Function) {
    return this.geocoder.getAddress(location, cb);
  }
}
